import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { useClassNames } from './Paragraph.styles';

/**
 * Paragraph is a simple styled replacement for a `p` tag.
 */
const Paragraph: FC<PropsWithChildren> = ({ children }) => (
  // eslint-disable-next-line @ms/jsx-forbid-elements
  <p className={useClassNames().root}>{children}</p>
);

export default Paragraph;
